import React from 'react';
import './EVMap.scss';

interface IEVCutline {
  cutlineText: string;
}

export function EVCutline({ cutlineText }: IEVCutline): JSX.Element {
  return (
    <div className="ev-map__textbox">
      <p className="ev-map__cutline ahm-label3">{cutlineText}</p>
    </div>
  );
}

export default EVCutline;
